import { accMohSetupStep } from './acc-moh-setup.step';
import { appointmentAutomationsStep } from './appointment-automations.step';
import { conditionsSetupStep } from './conditions-setup.step';
import { customFormsStep } from './custom-forms.step';
import { documentTemplatesStep } from './document-templates.step';
import { externalContactsStep } from './external-contacts.step';
import { feeScheduleStep } from './fee-schedule.step';
import { generalSettingsStep } from './general-settings.step';
import { labsStep } from './labs.step';
import { medicalHistoryAlertsStep } from './medical-history-alerts.step';
import { multiTreatmentsSetupStep } from './multi-treatments-setup.step';
import { practiceInfoStep } from './practice-info.step';
import { IPracticeSetupStepDefinition } from './practice-setup-step.types';
import { prescriptionsSetupStep } from './prescriptions-setup.step';
import { productsForSaleStep } from './products-for-sale.step';
import { providerNumbersStepAU } from './provider-numbers-au.step';
import { providerNumbersStepNZ } from './provider-numbers-nz.step';
import { referralSourcesStep } from './referral-sources.step';
import { roleSettingsStep } from './role-settings.step';
import { rosterSetupStep } from './roster-setup.step';
import { snippetsStep } from './snippets.step';
import { staffSetupStep } from './staff-setup.step';
import { sterilisationTrackingStep } from './sterilisation-tracking.step';
import { tagsSetupStep } from './tags-setup.step';
import { teamsSetupStep } from './teams-setup.step';
import { transactionTypesStep } from './transaction-types.step';
import { treatmentCategoriesStep } from './treatment-categories.step';
import { treatmentTemplatesSetupStep } from './treatment-templates-setup.step';
import { treatmentsSetupStep } from './treatments-setup.step';

const generalPracticeSettingsSteps: IPracticeSetupStepDefinition[] = [
  practiceInfoStep,
  roleSettingsStep,
  staffSetupStep,
  providerNumbersStepAU,
  providerNumbersStepNZ,
  rosterSetupStep,
  teamsSetupStep,
];

const feesAndAccountingSteps: IPracticeSetupStepDefinition[] = [
  transactionTypesStep,
  feeScheduleStep,
];

const conditionsAndTreatmentsSteps: IPracticeSetupStepDefinition[] = [
  conditionsSetupStep,
  treatmentCategoriesStep,
  treatmentsSetupStep,
  multiTreatmentsSetupStep,
  treatmentTemplatesSetupStep,
];

const miscellaneousSteps: IPracticeSetupStepDefinition[] = [
  referralSourcesStep,
  externalContactsStep,
  tagsSetupStep,
  customFormsStep,
  medicalHistoryAlertsStep,
  sterilisationTrackingStep,
];

const additionalSettingsSteps: IPracticeSetupStepDefinition[] = [
  generalSettingsStep,
  appointmentAutomationsStep,
  productsForSaleStep,
  labsStep,
  snippetsStep,
  documentTemplatesStep,
  prescriptionsSetupStep,
  // reschedulingAndCancellationStep,
  accMohSetupStep,
  // taskSetupStep,
];

/**
 * Master list of all practice setup step definitions. The array order determines
 * the display order in the setup wizard UI. Region-specific steps are filtered
 * at runtime via {@link PracticeSetupWizard.getRegionFilteredSteps}.
 *
 * Each step definition includes a unique `id` (from {@link PracticeSetupStepId})
 * that ties it to a persisted wizard step document. When the wizard page loads,
 * {@link PracticeSetupWizardStepResync.run} reconciles persisted steps against
 * this list — adding any new definitions and retiring steps whose `id` no longer
 * appears here.
 */
export const PRACTICE_SETUP_STEPS: IPracticeSetupStepDefinition[] = [
  ...generalPracticeSettingsSteps,
  ...conditionsAndTreatmentsSteps,
  ...feesAndAccountingSteps,
  ...miscellaneousSteps,
  ...additionalSettingsSteps,
];
